module.exports = __webpack_public_path__ + "img/equal.7a0e3e24.svg";